/** Only a canonical, internal checkout-result URL may survive sign-in. */
export function getPaymentReturnPath(value) {
  if (typeof value !== "string" || !value.startsWith("/subscription/return?")) return null;
  try {
    const url = new URL(value, "https://aviafy.invalid");
    const orders = url.searchParams.getAll("order_id");
    const order = orders[0];
    if (url.origin !== "https://aviafy.invalid" || url.pathname !== "/subscription/return" || url.hash ||
        // eslint-disable-next-line no-control-regex -- Checkout references must not contain control characters.
        orders.length !== 1 || !order || order.trim() !== order || order.length > 1024 || /[\x00-\x1f\x7f]/.test(order)) return null;
    return `/subscription/return?${new URLSearchParams({ order_id: order })}`;
  } catch { return null; }
}
